module.exports = __webpack_public_path__ + "images/category_lp/macbook/store_images/3@2x_d44f2b354063632b4be78fe017346846.png";